import {Component, HostListener, OnInit} from '@angular/core';

/**
 * Aviso para instalar el portal como aplicacion.
 *  - Android y escritorio (Chrome, Edge): el navegador avisa con
 *    `beforeinstallprompt` y se ofrece el boton Instalar.
 *  - iPhone / iPad: Apple no permite instalar desde un boton; se muestran los
 *    pasos (Compartir -> Agregar a pantalla de inicio), y solo en Safari, que
 *    es el unico navegador de iOS que lo permite.
 * No aparece si ya se abrio como app instalada, dentro del APK de Android, o
 * si la persona lo cerro (vuelve a ofrecerse a los 30 dias).
 */
@Component({
  selector: 'app-instalar-app',
  templateUrl: './instalar-app.component.html',
  styleUrls: ['./instalar-app.component.scss']
})
export class InstalarAppComponent implements OnInit {
  private static readonly CLAVE = 'instalarAppOculto';
  private static readonly DIAS_OCULTO = 30;

  visible = false;
  modo: 'boton' | 'ios' = 'boton';
  private eventoInstalar: any = null;

  ngOnInit() {
    if (this.yaInstalada() || this.ocultoPorLaPersona()) {
      return;
    }
    if (this.esSafariDeIos()) {
      this.modo = 'ios';
      this.visible = true;
    }
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  alPoderInstalar(evento: any) {
    evento.preventDefault();
    this.eventoInstalar = evento;
    // en iPhone manda la guia de pasos: ahi no existe instalacion por boton
    if (!this.yaInstalada() && !this.ocultoPorLaPersona() && !this.esSafariDeIos()) {
      this.modo = 'boton';
      this.visible = true;
    }
  }

  @HostListener('window:appinstalled')
  alInstalar() {
    this.visible = false;
  }

  instalar() {
    if (!this.eventoInstalar) {
      return;
    }
    this.eventoInstalar.prompt();
    this.eventoInstalar.userChoice.then(() => {
      this.eventoInstalar = null;
      this.visible = false;
    });
  }

  cerrar() {
    this.visible = false;
    try {
      localStorage.setItem(InstalarAppComponent.CLAVE, String(Date.now()));
    } catch (e) {
    }
  }

  private yaInstalada(): boolean {
    const nav: any = window.navigator;
    const comoApp = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
    // window.Capacitor existe cuando el portal corre dentro del APK de Android
    return !!comoApp || nav.standalone === true || !!(window as any).Capacitor;
  }

  private ocultoPorLaPersona(): boolean {
    try {
      const desde = Number(localStorage.getItem(InstalarAppComponent.CLAVE));
      return !!desde && (Date.now() - desde) < InstalarAppComponent.DIAS_OCULTO * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  private esSafariDeIos(): boolean {
    const ua = window.navigator.userAgent;
    // iPadOS se presenta como Mac: se distingue por la pantalla tactil
    const esIos = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && window.navigator.maxTouchPoints > 1);
    return esIos && /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  }

}
